import { AssetModel } from "@interfaces/index";
import { getLabelFileAgreementField } from "@utils/index";

export const getUploadLaterDocsTitle = (
  asset: AssetModel | Omit<AssetModel, "attachments" | "userBusiness">,
) => {
  let result = asset.uploadLaterAgreement
    ? getLabelFileAgreementField(asset.type, asset.purchaseType)
    : "";
  result += result && asset.uploadLaterInvoice ? " • " : "";
  result += asset.uploadLaterInvoice ? "Invoice" : "";

  return result;
};
